import { render, staticRenderFns } from "./ParentProductMgmt.vue?vue&type=template&id=38763e91"
import script from "./ParentProductMgmt.vue?vue&type=script&lang=js"
export * from "./ParentProductMgmt.vue?vue&type=script&lang=js"
import style0 from "./ParentProductMgmt.vue?vue&type=style&index=0&id=38763e91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports